// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__SHksz","header_title":"style_header_title__ovFmR","header":"style_header__dI0as"};